import React, { useEffect, useState } from "react";
import Highlighter from "react-highlight-words";
import { MdDelete, MdFlightTakeoff } from "react-icons/md";
import { deleteGroupDelete, deleteRowDelete, updateDefaultFieldsArray } from "../../candidateListFunctions";
import { IoSettingsOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import CandidateFilterPopup from "../../CandidateFilterPopup";
import { AiOutlineCloudUpload, AiOutlineFilter } from "react-icons/ai";
import SettingsPopup from "../../../../../../../../ReusableComponents/SettingsPopup/SettingsPopup";
import PromptElement from "../../../../../../PromptElement";
import { RiFileExcel2Line } from "react-icons/ri";
import GroupEditPopup from "../../GroupEditPopup";
import FlightDetailsExcel from "../../excel/FlightDetailsTemplate";
import flightDetails from "../../excel/FlightDetails";
import CandidateErrorPopUp from "../../CandidateErrorPopUp";
import FileUploadPopup from "../UpdateVisaDetails/FileUploadPopup";
import DownloadPDFPopup from "./DownloadPDFPopup";
import EditCandidate from "../../EditCandidate";
import AddFlightDetails from "./AddFlightDetails";
import SearchFilter from "../../../../../../../../components/SmartDataTable/SearchFilter";
import PaginationControls from "../../../../../../../../components/SmartDataTable/PaginationControls";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export default function ListDataUpdateFlightDetials({
  candidateData = [],
  setCandidateListData,
  projectId,
  setOpenCandidateUpload,
}) {
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState("");
  const [searchWords, setSearchWords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const [filterView, setFilterView] = useState(false);
  const [filteringKeys, setFilteringKeys] = useState({});
  const [showSettings, setShowSettings] = useState(false);
  const [openDeletePopup, setOPenDeletePopup] = useState({ open: false, id: "" });
  const [groupEditPopupState, setGroupEditPopupState] = useState({ open: false });
  const [groupDeletePopupState, setGroupDeletePopupState] = useState({ open: false });
  const [editCandidatePopup, setEditCandidatePopup] = useState({ open: false, id: "", editData: "" });
  const [defaultFields, setDefaultFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [bulkUploadPopupState, setBulkUploadPopupState] = useState({ open: false });
  const [groupDownloadPopupState, setgroupDownloadPopupState] = useState({ open: false });
  const [showErrorPopUp, setShowErrorPopUp] = useState();
  const [checkedList, setCheckedList] = useState([]);
  const [addFlightDetailsPopup, setAddFlightDetailsPopup] = useState(false);

  const order = [
    "name", "passport_number", "candidate_id", "job_position_name",
    "visa_profession_name", "nationality_name", "religion",
    "candidate_flight_flight_details", "candidate_flight_country",
    "candidate_flight_date_of_arrival", "candidate_flight_sector_name",
    "candidate_flight_pickup_to_be_arranged", "status", "not_travelled_instance",
  ];
  const options = [{ startingWith: "candidate_flight", default: true }];
  const removeList = ["candidate_flight_pax", "candidate_flight_flight_status"];

  useEffect(() => {
    const fields = updateDefaultFieldsArray({ candidateData, order, options, removeList }) || [];
    setDefaultFields(fields);
    setSelectedFields(fields.filter((d) => d.default));
  }, [candidateData]);

  const allData = candidateData?.candidates?.filter(
    (d) => d?.status === "VISA STAMPED" && d?.candidate_file?.status === "Completed"
  ) || [];

  const filtered = searchTerm.trim()
    ? allData.filter((item) =>
        selectedFields.some((f) =>
          String(item[f.value] ?? "").toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    : allData;

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const safePage = Math.min(currentPage, totalPages);
  const pageData = filtered.slice((safePage - 1) * pageSize, safePage * pageSize);

  useEffect(() => { setCheckedList([]); }, [safePage, pageSize]);

  const deleteData = async (rowID) => {
    const response = await deleteRowDelete(projectId, { candidate: [{ id: rowID }] }, setCandidateListData, dispatch);
    if (response.completed) setOPenDeletePopup({ open: false, id: "" });
  };

  const handleGroupDelete = async () => {
    const arr = checkedList.map((id) => ({ id }));
    const response = await deleteGroupDelete(projectId, { candidate: arr }, setCandidateListData, setDeleteLoading, dispatch);
    if (response.completed) setGroupDeletePopupState({ open: false });
  };

  const FilterColumn = () => null;
  const ResetFilter = () => { setFilteringKeys({}); setSearchTerm(""); };

  return (
    <>
      {editCandidatePopup?.open && (
        <EditCandidate showPromptElement={editCandidatePopup} setShowPromptElement={setEditCandidatePopup} candidateListData={candidateData} projectId={projectId} setCandidateListData={setCandidateListData} updateVisaDetails={true} ResetFilter={ResetFilter} />
      )}
      {showSettings && <SettingsPopup showPopup={showSettings} setShowPopup={setShowSettings} initialState={defaultFields} finalState={selectedFields} setFinalState={setSelectedFields} />}
      {openDeletePopup.open && <PromptElement showPromptElement={openDeletePopup} setShowPromptElement={setOPenDeletePopup} deleteHandler={deleteData} />}
      {groupDeletePopupState.open && <PromptElement showPromptElement={groupDeletePopupState} setShowPromptElement={setGroupDeletePopupState} deleteHandler={handleGroupDelete} />}
      {groupEditPopupState.open && (
        <GroupEditPopup popupState={groupEditPopupState} setPopupState={setGroupEditPopupState} candidateData={candidateData} setCandidateListData={setCandidateListData} checkedList={checkedList} ResetFilter={ResetFilter} />
      )}
      {filterView && (
        <CandidateFilterPopup filterView={filterView} setFilterView={setFilterView} candidateData={candidateData} setCandidateListData={setCandidateListData} FilterColumn={FilterColumn} ResetFilter={ResetFilter} filteringKeys={filteringKeys} />
      )}
      {bulkUploadPopupState.open && (
        <FileUploadPopup popupState={bulkUploadPopupState} setPopupState={setBulkUploadPopupState} setShowErrorPopUp={setShowErrorPopUp} />
      )}
      {groupDownloadPopupState.open && (
        <DownloadPDFPopup popupState={groupDownloadPopupState} setPopupState={setgroupDownloadPopupState} selectedRowsData={candidateData?.candidates?.filter((d) => checkedList.includes(d?.id))} company={candidateData?.company} />
      )}
      {showErrorPopUp && <CandidateErrorPopUp showErrorPopUp={showErrorPopUp} onToggle={() => setShowErrorPopUp(false)} title="Validation Error" />}
      {addFlightDetailsPopup && (
        <AddFlightDetails popupState={addFlightDetailsPopup} setPopupState={setAddFlightDetailsPopup} candidateData={candidateData} setCandidateListData={setCandidateListData} />
      )}

      {/* Toolbar */}
      <div className="flex flex-wrap gap-2 items-center w-full mb-4 flex-row-reverse">
        <SearchFilter searchTerm={searchTerm} onSearchChange={(val) => { setSearchTerm(val); setSearchWords(val ? val.trim().split(/\s+/) : []); setCurrentPage(1); }} placeholder="Search across all columns..." />
        <div className="flex flex-wrap gap-2 items-center">
          {/* Download Excel */}
          <div className="relative">
            <div className="peer">
              <button className="flex items-center gap-2 bg-blue text-white p-2 px-3 rounded-md text-sm">
                Download Excel <RiFileExcel2Line size="1.1rem" />
              </button>
            </div>
            <div className="hidden absolute right-0 top-full w-[14rem] bg-white shadow-xl rounded-lg pt-2 px-2 pb-2 ring-1 ring-slate-400 peer-hover:flex hover:flex flex-col gap-2 z-50">
              <button onClick={() => flightDetails(pageData, candidateData?.project)} disabled={pageData.length <= 0}
                className="flex justify-center items-center gap-2 ring-1 ring-slate-300 font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs disabled:bg-slate-300 disabled:cursor-not-allowed hover:bg-blue hover:text-white">
                Flight Details Report
              </button>
              <button onClick={() => FlightDetailsExcel("Flight Details Template", candidateData)}
                className="flex justify-center items-center gap-2 ring-1 ring-slate-300 font-semibold text-black bg-slate-50 p-2 px-3 rounded-md w-full text-xs hover:bg-blue hover:text-white">
                Template - Flight Details
              </button>
            </div>
          </div>
          <button onClick={() => setOpenCandidateUpload(true)} className="flex items-center gap-2 p-2 px-3 rounded-md bg-blue text-white text-sm">
            Upload Flight Details <AiOutlineCloudUpload size="1.1rem" />
          </button>
          <button onClick={() => setAddFlightDetailsPopup(true)} className="flex items-center gap-2 p-2 px-3 rounded-md bg-blue text-white text-sm">
            Add Flight Details <MdFlightTakeoff size="1.1rem" />
          </button>
          <button className="flex items-center gap-2 bg-blue text-white p-2 px-3 rounded-md text-sm disabled:bg-blue/70 disabled:cursor-not-allowed" onClick={() => setFilterView(true)} disabled={pageData.length <= 0}>
            Filter <AiOutlineFilter size="1.1rem" />
          </button>
          <button onClick={() => setShowSettings(true)} className="disabled:cursor-not-allowed" disabled={pageData.length <= 0}>
            <IoSettingsOutline size="1.2rem" />
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow max-h-[70vh] p-2">
        <table className="min-w-full">
          <thead className="bg-gray-50 sticky top-0 z-20 shadow-sm">
            <tr className="bg-gray-50">
              <th className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider bg-gray-50 whitespace-nowrap" style={{ backgroundColor: '#f9fafb' }}>S.NO.</th>
              {selectedFields.map((f) => (
                <th
                  key={f.id}
                  className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider bg-gray-50 whitespace-nowrap"
                  style={{ backgroundColor: '#f9fafb' }}
                >
                  {f.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {allData.length === 0 ? (
              <tr><td colSpan={selectedFields.length + 1} className="px-6 py-8 text-center text-gray-500">No visa stamped candidates with completed documents found.</td></tr>
            ) : pageData.length === 0 ? (
              <tr><td colSpan={selectedFields.length + 1} className="px-6 py-8 text-center text-gray-500">{`No results found for "${searchTerm}"`}</td></tr>
            ) : (
              pageData.map((data, index) => (
                <tr key={data?.id} className={`border-b-[1.5px] border-slate-100 hover:bg-gray-50 ${data?.candidate_file?.status === "Not Completed" ? "bg-violet-50" : ""}`}>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{(safePage - 1) * pageSize + index + 1}</td>
                  {selectedFields.map((f) => (
                    <td key={f.id} className="px-6 py-6 whitespace-nowrap text-base text-gray-700">
                      {String(data[f.value] ?? "").startsWith("http") ? (
                        <a className="link link-hover link-neutral" href={data[f.value]} target="_blank" rel="noopener noreferrer">View</a>
                      ) : (
                        <Highlighter searchWords={searchWords} autoEscape textToHighlight={data[f.value] !== undefined && data[f.value] !== null ? String(data[f.value]) : "-"} />
                      )}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <PaginationControls currentPage={safePage} totalPages={totalPages} pageSize={pageSize} totalRecords={filtered.length} pageSizeOptions={PAGE_SIZE_OPTIONS} onPageChange={(p) => setCurrentPage(p)} onPageSizeChange={(s) => { setPageSize(s); setCurrentPage(1); }} />
    </>
  );
}
